function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { FormBuilder, Handler, magic, MagicFetch, MagicFormBrick, MagicFormButtonDeleteBrick, MagicFormButtonFilesBrick, MagicFormButtonReloadBrick, MagicFormButtonSaveBrick, MagicFormWrapperBrick, MagicInputSelectorBrick, MagicInputTextBrick, MagicListBrick, MagicListCardAvatarBrick } from "zengular-magic";
import indexFeature from "../../../Andesite/Ghost/descriptors/index-feature";
var handler = new Handler('index-feature');

handler.fetcher = /*#__PURE__*/function (_MagicFetch) {
  _inherits(_class, _MagicFetch);

  var _super = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "api",
    get: function get() {
      return '/api/handler/index-feature';
    }
  }]);

  return _class;
}(MagicFetch);

handler.list = /*#__PURE__*/function (_MagicListBrick) {
  _inherits(_class2, _MagicListBrick);

  var _super2 = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super2.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "card",
    get: function get() {
      return /*#__PURE__*/function (_MagicListCardAvatarB) {
        _inherits(_class3, _MagicListCardAvatarB);

        var _super3 = _createSuper(_class3);

        function _class3() {
          _classCallCheck(this, _class3);

          return _super3.apply(this, arguments);
        }

        _createClass(_class3, [{
          key: "label",
          get: function get() {
            return this.item.title;
          }
        }, {
          key: "avatar",
          get: function get() {
            return this.item.image;
          }
        }, {
          key: "status",
          get: function get() {
            return this.item.status;
          }
        }, {
          key: "icon",
          get: function get() {
            return this.item.position > 0 ? "fas fa-map-marker-alt" : false;
          }
        }, {
          key: "properties",
          get: function get() {
            return {
              position: this.item.position
            };
          }
        }]);

        return _class3;
      }(MagicListCardAvatarBrick);
    }
  }, {
    key: "sorting",
    get: function get() {
      return {
        relevance: {
          status: 'desc',
          id: 'desc'
        }
      };
    }
  }]);

  return _class2;
}(MagicListBrick);

handler.form = /*#__PURE__*/function (_MagicFormWrapperBric) {
  _inherits(_class4, _MagicFormWrapperBric);

  var _super4 = _createSuper(_class4);

  function _class4() {
    _classCallCheck(this, _class4);

    return _super4.apply(this, arguments);
  }

  _createClass(_class4, [{
    key: "label",
    get: function get() {
      return this.item.title;
    }
  }, {
    key: "form",
    get: function get() {
      return /*#__PURE__*/function (_MagicFormBrick) {
        _inherits(_class5, _MagicFormBrick);

        var _super5 = _createSuper(_class5);

        function _class5() {
          _classCallCheck(this, _class5);

          return _super5.apply(this, arguments);
        }

        _createClass(_class5, [{
          key: "formBuilder",
          get: function get() {
            var formBuilder = new FormBuilder();
            var section;
            section = formBuilder.add();
            section.add(indexFeature.fields.title);
            section.add(indexFeature.fields.lead, MagicInputTextBrick);
            section.add.inline(indexFeature.fields.articleId, MagicInputSelectorBrick, MagicInputSelectorBrick.setAttributes('/api/articles'));
            section.add.inline(indexFeature.fields.status);
            section.add.inline(indexFeature.fields.position).setHint("Ha fix poz\xEDci\xF3ba szeretn\xE9d helyezni a feature-t, akkor ide adj meg egy sz\xE1mot! Ha automatikusan szeretn\xE9d, hogy kezelje a rendszer, akkor 0!");
            section.add.inline(indexFeature.fields.preserveImage).setHint("Akkor kapcsold ezt be, ha nem szeretn\xE9d, hogy a rendszer \xE1tm\xE9retezze a felt\xF6lt\xF6tt k\xE9pet.\n\t\t\t\t\t\t\t\tEz akkor kell, ha animgif-et szeretn\xE9l megjelen\xEDteni. Ekkor neked kell gondoskodnod a k\xE9p\n\t\t\t\t\t\t\t\tm\xE9retez\xE9sr\u0151l (280x215)! Animgif \xE1tm\xE9retez\u0151: <a href=\"https://ezgif.com/resize\" target=\"_blank\">ezgif</a>");
            return formBuilder;
          }
        }]);

        return _class5;
      }(MagicFormBrick);
    }
  }, {
    key: "buttons",
    get: function get() {
      return [MagicFormButtonSaveBrick, MagicFormButtonFilesBrick, MagicFormButtonReloadBrick, MagicFormButtonDeleteBrick];
    }
  }]);

  return _class4;
}(MagicFormWrapperBrick);

handler.dictionary = {
  "icon": {
    "small": "fad fa-file-alt",
    "large": "fad fa-file-alt"
  },
  "label": {
    "menu": "Kiemelt tartalmak",
    "list": "Kiemelt tartalmak",
    "form": "Kiemelt tartalom"
  },
  "order": {
    "id": "id"
  },
  "card": {
    "property": {
      "position": "pozíció",
      "status": "státusz"
    }
  },
  "input": {
    "title": "cím",
    "subtitle": "alcím",
    "preserveimage": "eredeti kép",
    "status": "státusz",
    "position": "pozíció",
    "articleid": "cikk"
  }
};
magic.addHandler(handler);